module.exports = __webpack_public_path__ + "static/media/1.49d9a7c3.jpg";